import { GQLIdEncoder } from '../../../common/utils/GQLIdEncoder';
import { ReportCallSite } from '../models/ReportCallSite';

export class ReportCallSiteMapper {
  readonly gqlIdEncoder = new GQLIdEncoder();

  mapGQLModel(data: any): ReportCallSite {
    return new ReportCallSite(
      this.gqlIdEncoder.decode(data.id),
      data.covered,
      data.class,
      data.method,
      data.file,
      data.line,
      data.calledClass,
      data.calledMethod
    );
  }
}
